import { TFunction } from 'i18next';

type TaskAction = {
  label: string;
  onSelect: () => Promise<void>;
};

type BuildTaskActionsParams = {
  canCreateServiceRequest: boolean;
  onExport: () => Promise<void>;
  onGenerateServiceRequest: () => void;
  t: TFunction;
};

export function buildTaskActions({
  canCreateServiceRequest,
  onExport,
  onGenerateServiceRequest,
  t,
}: BuildTaskActionsParams): TaskAction[] {
  const actions: TaskAction[] = [
    {
      label: t(
        'web.admin.workOrder.preventiveMaintenance.task.details.actions.export'
      ),
      onSelect: onExport,
    },
  ];

  if (canCreateServiceRequest) {
    actions.push({
      label: t(
        'web.admin.workOrder.preventiveMaintenance.task.details.actions.generateServiceRequest'
      ),
      onSelect: async () => onGenerateServiceRequest(),
    });
  }

  return actions;
}
